// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import globalFuc from './my.global.js'

require('../node_modules/materialize-css/dist/css/materialize.css')
require('../node_modules/materialize-css/dist/js/materialize.js')
require('../node_modules/animate.css/animate.css')
require('./assets/css/animate.css')
// require('./assets/js/responsive.js')
Vue.config.productionTip = false
Vue.prototype.folderName = 'ali';

new Vue({
  el: '#app',
  template: '<App/>',
  components: { App }
})



// WEBPACK FOOTER //
// ./src/main.js